import { signIn, signOut } from 'aws-amplify/auth';

import { EVENT_MATCHES_EDIT_MODAL_HIDE, EVENT_MATCHES_EDIT_MODAL_SHOW } from '../constants/action-types';
import { deepCopy } from '../utils/deepCopy';

//--------------------------------------------------------------
// Event Viewer Modal
//--------------------------------------------------------------

export const matchesEditorModalOpen = (event) => {
  const clonedEvent = deepCopy(event);
  return {
    type: EVENT_MATCHES_EDIT_MODAL_SHOW,
    event: clonedEvent,
  };
};

export const matchesEditorModalClose = () => {
  return {
    type: EVENT_MATCHES_EDIT_MODAL_HIDE,
    event: null,
  };
};

//--------------------------------------------------------------
// AUTH
//--------------------------------------------------------------

export const failedAuthLogin = () => {
  console.trace('FAILED');
};

export function authLogin(user, password) {
  signIn({
    username: user,
    password,
    options: {
      authFlowType: 'USER_PASSWORD_AUTH',
    },
  }).catch((error) => authLogout());
}

export function authLogout() {
  signOut()
    .catch((error) => {
      console.error('Error during sign out:', error);
    })
    .finally(() => {
      localStorage.setItem('userLogged', 'false');
      window.location.href = '/';
    });
}
